import classNames from 'classnames';
import Image, { ImageProps } from 'components/gruenland/atoms/image';
import Link from 'components/gruenland/atoms/link';
import { GruenlandJuniorWhiteLogo } from 'components/svgr/GruenlandJuniorWhiteLogo';
import { TYPOGRAPHY_MOD06_TITLE } from 'lib/typography';

export type Module06Props = {
  title?: string;
  description?: string;
  image?: ImageProps;
  juniorLogo?: boolean;
  ctaLabel?: string;
};

export const Module06 = ({ title, description, image, juniorLogo, ctaLabel }: Module06Props) => {
  return (
    <>
      <div className="relative h-[400px] w-full">
        {image?.media?.resourceType === 'image' && (
          <Image {...image} alt={image.alt} className="object-cover brightness-50" fill />
        )}
        <div
          className={classNames('absolute inset-0 flex flex-col items-center p-[60px] lg:items-stretch', {
            'justify-center': !juniorLogo,
            'justify-end lg:justify-between': juniorLogo,
          })}
        >
          {juniorLogo && <GruenlandJuniorWhiteLogo />}
          <div className="hidden items-center justify-between lg:flex">
            <div className="flex flex-col gap-[15px] pe-[200px]">
              <h2 className={classNames(TYPOGRAPHY_MOD06_TITLE, 'text-center text-white lg:text-left')}>{title}</h2>
              <p className="text-white">{description}</p>
            </div>
            <div>
              <Link variant="buttonPrimaryNegative" link="/">
                {ctaLabel}
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-[15px] p-[30px] lg:hidden">
        <h2 className={classNames(TYPOGRAPHY_MOD06_TITLE, 'text-center lg:text-left')}>{title}</h2>
        <p>{description}</p>
        <Link variant="buttonPrimaryGreen" link="/" className="block">
          {ctaLabel}
        </Link>
      </div>
    </>
  );
};
